// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__XE6Zt","rotation":"SmallLoader_rotation__D46Wo"};